import { render, staticRenderFns } from "./AlignJustifyIcon.vue?vue&type=template&id=2e1530dc"
import script from "./AlignJustifyIcon.vue?vue&type=script&lang=js"
export * from "./AlignJustifyIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports